export default __webpack_public_path__ + "static/media/alertacc.3ad5c94a.svg";